import React from 'react';
import { TransferForm } from './TemplateTransferForm';

interface TmplTnsfStatusFooterProps {
  transferForm: TransferForm;
}

export default function TmplTnsfStatusFooter(
  props: React.HTMLAttributes<HTMLDivElement> & TmplTnsfStatusFooterProps
) {
  const { transferForm } = props;

  return (
    <div className={props.className}>
      {transferForm.target && (
        <div>
          <span>Target Selected: </span>
          <span className="font-semibold">{transferForm.target.name}</span>
        </div>
      )}
    </div>
  );
}
